import { autoserialize, autoserializeAs } from 'cerialize';
import { DocumentTypeStatus } from './document-type-status';
import { ScreeningPackageStatus } from './screening-package-status';
import { SigningTemplateStatus } from './signing-template-status';
import { CertificationCourseStatus } from './certification-course-status';
import { TransitProgram } from './transit-program';
import { TransitProgramDriver } from './transit-program-driver';

export class TransitProgramDriverStatus {

  @autoserialize
  transitProgramName: string;

  @autoserializeAs(TransitProgram)
  transitProgram: TransitProgram;

  @autoserializeAs(TransitProgramDriver)
  transitProgramDriver: TransitProgramDriver;

  @autoserialize
  requirementsMet: boolean;

  @autoserializeAs(DocumentTypeStatus)
  documentTypeStatuses: Array<DocumentTypeStatus>;

  @autoserializeAs(SigningTemplateStatus)
  signingTemplateStatuses: Array<SigningTemplateStatus>;

  @autoserializeAs(ScreeningPackageStatus)
  screeningPackageStatuses: Array<ScreeningPackageStatus>;

  @autoserializeAs(CertificationCourseStatus)
  certificationCourseStatuses: Array<CertificationCourseStatus>;

}
